import React from 'react';


export default function References() {
    return (
        <div style={{padding: '30px'}}>
            <h2>COCOMAPS 2</h2>
            <p>COCOMAPS 2.0: a web server for identifying, analyzing, and visualizing atomic interactions at the interface of biomolecular complexes Chawla, M.; Kalra, U.; Petta, A.; Sharma, S.; Shaikh, A. R.; Cavallo, L.; Oliva, R. Bioinformatics 2025, 41, btaf606. (<a href='https://academic.oup.com/bioinformatics/article/41/12/btaf606/8363873'>link</a>)</p>
            <br/><br/>

            <h2>COCOMAPS 1</h2>
            <p>Vangone A, Spinelli R, Scarano V, Cavallo L, Oliva R. (2011). COCOMAPS: a web application to analyze and visualize contacts at the interface of biomolecular complexes. Bioinformatics 27, 2915-6.</p>
            <br/><br/>

            <h2>HBPLUS</h2>
            <p>McDonald, I.K. and Thornton, J.M. (1994). Satisfying hydrogen bonding potential in proteins. J. Mol. Biol. 238, 777-793. </p>
            <br/><br/>

            <h2>HBADD</h2>
            <p>Wallace, A. C., Laskowski, R. A., & Thornton, J. M. (1995). LIGPLOT: A program to generate schematic diagrams of protein-ligand interactions. Protein Engineering 8, 127–134. </p>
            <br/><br/>

            <h2>CCTBX</h2>
            <p>https://github.com/cctbx/cctbx_project/tree/master/cctbx</p>
            <br/><br/>

            <h2>Reduce</h2>
            <p>Word, J. M., Lovell, S. C., Richardson, J. S., & Richardson, D. C. (1999). Asparagine and glutamine: Using hydrogen atom contacts in the choice of side-chain amide orientation. J. Mol. Biol. 285, 1735-1747. </p>
            <br/><br/>

            <h2>Biopython</h2>
            <p>Cock, P. J. A., Antao, T., Chang, J. T., Chapman, B. A., Cox, C. J., Dalke, A., Friedberg, I., Hamelryck, T., Kauff, F., Wilczynski, B., & de Hoon, M. J. L. (2009). Biopython: Freely available Python tools for computational
                molecular biology and bioinformatics. Bioinformatics 25, 1422-1423. </p>
            <br/><br/>

            <h2>NACCESS</h2>
            <p>Hubbard, S.J. and Thornton, J.M. (1993) ‘NACCESS’, computer program. Department of Biochemistry and Molecular Biology, University College, London.</p>
            <br/><br/>

            <h2>Mol*</h2>
            <p>Sehnal, D., Bittrich, S., Deshpande, M., Svobodová, R., Berka, K., Bazgier. V., Velankar, S., Burley, S.K., Koča, J., Rose, A.S. (2021. Mol* Viewer: modern web app for 3D visualization and analysis of large biomolecular
                structures. Nucleic Acids Res. 49(W1):W431-W437.</p>
        </div>
    )
}